/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".progress-wrapper[_ngcontent-%COMP%]{padding-left:2rem;padding-right:2rem;margin-bottom:0;width:100%;display:-ms-grid;display:grid;grid-auto-columns:1fr;-ms-grid-rows:1fr;grid-template-rows:1fr}lp2-blob-progress-bar[_ngcontent-%COMP%]{-ms-grid-row:1;grid-row:1;width:100%}@media (max-width:710px){.non-current-level[_ngcontent-%COMP%]{display:none!important}}@media (min-width:580px) and (max-width:709px){.table[_ngcontent-%COMP%]{width:35rem}}@media (max-width:579px){.table[_ngcontent-%COMP%]{width:24rem}}"];
export { styles as styles };
//# sourceMappingURL=level-progress-bar.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/level-progress-bar/level-progress-bar.component.scss.shim.ngstyle.js
// module id = 1618
// module chunks = 27 28 29